(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halloween-claude-product"]) return;
  try {
    
document.querySelectorAll('[data-hwp]').forEach(function (root) {
  var slides = root.querySelectorAll('[data-hwp-slide]');
  var thumbs = root.querySelectorAll('[data-hwp-thumb]');
  var counter = root.querySelector('[data-hwp-counter]');
  var i = 0;

  function show(n) {
    if (!slides.length) return;
    i = (n + slides.length) % slides.length;
    slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
    if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
  }

  thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { show(idx); }); });
  var prev = root.querySelector('[data-hwp-prev]');
  var next = root.querySelector('[data-hwp-next]');
  if (prev) prev.addEventListener('click', function () { show(i - 1); });
  if (next) next.addEventListener('click', function () { show(i + 1); });

  var qty = root.querySelector('[data-hwp-qty]');
  var minus = root.querySelector('[data-hwp-minus]');
  var plus = root.querySelector('[data-hwp-plus]');
  if (qty && minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
  if (qty && plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

  var sticky = root.querySelector('[data-hwp-sticky]');
  if (sticky) {
    var onScroll = function () { sticky.classList.toggle('is-visible', window.scrollY > 500); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-claude-trust"] && !Shopify.designMode) return;
  try {
    
(function () {
  var label = document.querySelector('[data-hwc-coll-heading]');
  var heading = document.querySelector('.hwp__coll .hwp__h2');
  if (label && heading) {
    var text = label.textContent.trim();
    if (text) heading.textContent = text;
  }

  var picker = document.querySelector('[data-hwv]');
  var cart = document.querySelector('.hwp__cart');
  if (!picker || !cart) return;

  var data = [];
  try { data = JSON.parse(picker.querySelector('[data-hwv-json]').textContent); } catch (e) { return; }

  cart.parentNode.insertBefore(picker, cart);
  picker.removeAttribute('hidden');

  var selects = Array.prototype.slice.call(picker.querySelectorAll('[data-hwv-select]'));

  function apply() {
    var sel = selects.map(function (s) { return s.value; });
    var v = data.find(function (c) { return sel.every(function (val, i) { return c.options[i] === val; }); });
    if (!v) return;

    document.querySelectorAll('.hwp input[name="id"], .hwp__sticky input[name="id"]').forEach(function (input) { input.value = v.id; });

    var now = document.querySelector('.hwp__prices .hwp__now');
    var was = document.querySelector('.hwp__prices .hwp__was');
    if (now) now.textContent = v.price;
    if (was) { was.textContent = v.onSale ? v.compare : ''; was.style.display = v.onSale ? '' : 'none'; }

    var sNow = document.querySelector('.hwp__sticky-price .hwp__now');
    var sWas = document.querySelector('.hwp__sticky-price .hwp__was');
    if (sNow) sNow.textContent = v.price;
    if (sWas) { sWas.textContent = v.onSale ? v.compare : ''; sWas.style.display = v.onSale ? '' : 'none'; }

    document.querySelectorAll('.hwp__add').forEach(function (btn) {
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to cart' : 'Sold out';
    });

    if (v.img) {
      var file = v.img.split('/').pop().split('?')[0];
      document.querySelectorAll('[data-hwp-slide]').forEach(function (slide, i) {
        if (slide.getAttribute('src').indexOf(file) !== -1) {
          var thumb = document.querySelector('[data-hwp-thumb="' + i + '"]');
          if (thumb) thumb.click();
        }
      });
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', apply); });
  apply();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
